export type LandingEdge = "top" | "right" | "bottom" | "left";

export interface FireflyLanding {
  targetKey: string;
  edge: LandingEdge;
  t: number;
}

export interface PageRect {
  left: number;
  top: number;
  right: number;
  bottom: number;
  width: number;
  height: number;
}

const EDGES: LandingEdge[] = ["top", "right", "bottom", "left"];

export function hashString(value: string): number {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

export function getStableLanding(
  petId: string,
  slot: number,
  targetKeys: string[]
): FireflyLanding | null {
  if (!targetKeys.length) return null;

  const seed = hashString(`${petId}:${slot}`);
  return {
    targetKey: targetKeys[seed % targetKeys.length],
    edge: EDGES[(seed >>> 8) % EDGES.length],
    t: 0.18 + ((seed >>> 16) % 6401) / 10000,
  };
}

export function getLandingPoint(
  rect: PageRect,
  landing: FireflyLanding,
  ellipse = false
) {
  if (ellipse) {
    const edgeIndex = EDGES.indexOf(landing.edge);
    const angle = ((edgeIndex + landing.t) * Math.PI) / 2 - Math.PI * 0.75;
    return {
      x: rect.left + rect.width / 2 + (Math.cos(angle) * rect.width) / 2,
      y: rect.top + rect.height / 2 + (Math.sin(angle) * rect.height) / 2,
    };
  }
  if (landing.edge === "top") {
    return { x: rect.left + rect.width * landing.t, y: rect.top };
  }
  if (landing.edge === "right") {
    return { x: rect.right, y: rect.top + rect.height * landing.t };
  }
  if (landing.edge === "bottom") {
    return { x: rect.left + rect.width * landing.t, y: rect.bottom };
  }
  return { x: rect.left, y: rect.top + rect.height * landing.t };
}
